/**
 * Created by Ning Jiang on 2022-03-08.
 */

import {SerialSymbol} from "./SerialSymbol";
import {SerialSymbolState} from "./SerialSymbolConfig";
import {gsap} from "gsap";
import {Serial} from "../Serial";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Layers, SerialLayers} from "../view/SerialLayers";

export class InfectiousSymbol extends SerialSymbol {

    private _multiplier:number;

    constructor(symbolName:string, reelId:number, symbolHeight:number, initState:SerialSymbolState) {
        const names = symbolName.split(":");
        super(names[0], reelId, symbolHeight, initState);
        this.blockReelLandingSound = true;
        this._multiplier = parseInt(names[1]);
        this._multiplierSize = 42;
        this._multiplierLetterSpacing = -15;
    }

    public showInfectious(isTop:boolean):gsap.core.Animation {
        const infectious = Serial.model.parsedGameData.infectiousWays.filter(inf => inf.symName === this.symbolName)[0];
        Serial.ways.updateWays(this.reelId, infectious.row, this._multiplier);
        const spine = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("infectious"));
        spine.autoUpdate = true;
        const position = this.getGlobalPosition();
        spine.position.set(position.x, position.y);
        SerialLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(spine);
        spine.state.setAnimation(0, "multiplier", false);
        const tl = gsap.timeline();
        tl.add([
            gsap.to(this, {duration : spine.spineData.findAnimation("multiplier").duration}),
            this.showInfectiousMultiplier(`X${this._multiplier}`, position, isTop)
        ]);
        tl.add(() => {
            this.showMultiplier(`X${this._multiplier}`);
            if(spine && spine.parent) {
                spine.parent.removeChild(spine);
                spine.destroy();
            }
        });
        return tl;
    }

    public showInfectiousMultiplier(text:string, position:PIXI.Point, isTop:boolean):TimelineLite {
        this.createMultiplier();
        this._multiplierText.text = text;
        this._multiplierContainer.position.set(position.x - 63, position.y - 10 + (isTop ? 42 : -42));
        SerialLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(this._multiplierContainer);
        const tl = gsap.timeline();
        tl.add(gsap.fromTo(this._multiplierContainer.scale, {x : 1.3, y : 1.3}, {x : 1.3, y : 1.3, duration : 0.134}));
        tl.add(gsap.to(this._multiplierContainer.scale, {x : 0.85, y : 0.85, duration : 0.033}));
        tl.add(gsap.to(this._multiplierContainer.scale, {x : 0.9, y : 0.9, duration : 0.033}));
        tl.add(gsap.to(this._multiplierContainer.scale, {x : 0.85, y : 0.85, duration : 0.1}));
        tl.add(gsap.to(this._multiplierContainer, {x : position.x, y : position.y - 10, duration : 0.134}), 0);
        return tl;
    }

    public showMultiplier(text:string, layer?:StageLayer, x?:number, y?:number):gsap.core.Animation {
        this._multiplierText.text = text;
        this._multiplierContainer.position.set(0, -10);
        this.addChild(this._multiplierContainer);
        return gsap.timeline();
    }
}